import _ from 'lodash';
import produce from 'immer';

import { defaultProcessingState } from '../utils';

import {
  BATCH_SEARCH_REQUEST_FIND_START,
  BATCH_SEARCH_REQUEST_FIND_FULFILL,
  BATCH_SEARCH_REQUEST_FIND_REJECT,
  BATCH_SEARCH_REQUEST_GET_START,
  BATCH_SEARCH_REQUEST_GET_FULFILL,
  BATCH_SEARCH_REQUEST_GET_REJECT,
  BATCH_SEARCH_REQUEST_REMOVE_START,
  BATCH_SEARCH_REQUEST_REMOVE_FULFILL,
  BATCH_SEARCH_REQUEST_REMOVE_REJECT,
  BATCH_SEARCH_RESULT_FIND_START,
  BATCH_SEARCH_RESULT_FIND_FULFILL,
  BATCH_SEARCH_RESULT_FIND_REJECT,
  BATCH_SEARCH_RESULT_GET_START,
  BATCH_SEARCH_RESULT_GET_FULFILL,
  BATCH_SEARCH_RESULT_GET_REJECT,
  BATCH_SEARCH_RESULT_ADD_TO_REPORT_START,
  BATCH_SEARCH_RESULT_ADD_TO_REPORT_FULFILL,
  BATCH_SEARCH_RESULT_ADD_TO_REPORT_REJECT,
  BATCH_SEARCH_REQUEST_UPDATE_START,
  BATCH_SEARCH_REQUEST_UPDATE_FULFILL,
  BATCH_SEARCH_REQUEST_UPDATE_REJECT,
} from './batch-search.actions';

const defaultState = {
  request: {
    find: defaultProcessingState(),
    get: defaultProcessingState(),
    update: defaultProcessingState(),
    remove: defaultProcessingState(),
    data: {},
  },
  result: {
    find: defaultProcessingState(),
    get: defaultProcessingState(),
    addToReport: defaultProcessingState(),
    data: {},
  },
};

export default produce((draft, action = {}) => {
  switch (action.type) {
    case BATCH_SEARCH_REQUEST_FIND_START: {
      ++draft.request.find.processing;
      draft.request.find.error = null;
      return draft;
    }

    case BATCH_SEARCH_REQUEST_FIND_FULFILL: {
      --draft.request.find.processing;
      draft.request.find.error = null;
      draft.request.data = {
        ...draft.request.data,
        ..._.keyBy(action.payload.result.data, 'id'),
      };
      return draft;
    }

    case BATCH_SEARCH_REQUEST_FIND_REJECT: {
      --draft.request.find.processing;
      draft.request.find.error = action.payload;
      return draft;
    }

    case BATCH_SEARCH_REQUEST_GET_START: {
      ++draft.request.get.processing;
      draft.request.get.error = null;
      return draft;
    }

    case BATCH_SEARCH_REQUEST_GET_FULFILL: {
      --draft.request.get.processing;
      draft.request.get.error = null;
      draft.request.data[action.payload.result.id] = action.payload.result;
      return draft;
    }

    case BATCH_SEARCH_REQUEST_GET_REJECT: {
      --draft.request.get.processing;
      draft.request.get.error = action.payload;
      return draft;
    }

    case BATCH_SEARCH_REQUEST_UPDATE_START: {
      ++draft.request.update.processing;
      draft.request.update.error = null;
      return draft;
    }

    case BATCH_SEARCH_REQUEST_UPDATE_FULFILL: {
      --draft.request.update.processing;
      draft.request.update.error = null;
      draft.request.data[action.payload.result.id] = action.payload.result;
      return draft;
    }

    case BATCH_SEARCH_REQUEST_UPDATE_REJECT: {
      --draft.request.update.processing;
      draft.request.update.error = action.payload;
      return draft;
    }

    case BATCH_SEARCH_REQUEST_REMOVE_START: {
      ++draft.request.remove.processing;
      draft.request.remove.error = null;
      return draft;
    }

    case BATCH_SEARCH_REQUEST_REMOVE_FULFILL: {
      --draft.request.remove.processing;
      draft.request.data = _.omit(draft.request.data, action.payload.result);
      draft.request.remove.error = null;
      return draft;
    }

    case BATCH_SEARCH_REQUEST_REMOVE_REJECT: {
      --draft.request.remove.processing;
      draft.request.remove.error = action.payload;
      return draft;
    }

    case BATCH_SEARCH_RESULT_FIND_START: {
      ++draft.result.find.processing;
      draft.result.find.error = null;
      return draft;
    }

    case BATCH_SEARCH_RESULT_FIND_FULFILL: {
      --draft.result.find.processing;
      draft.result.find.error = null;
      draft.result.data = {
        ...draft.result.data,
        ..._.keyBy(action.payload.result.data, 'id'),
      };
      return draft;
    }

    case BATCH_SEARCH_RESULT_FIND_REJECT: {
      --draft.result.find.processing;
      draft.result.find.error = action.payload;
      return draft;
    }

    case BATCH_SEARCH_RESULT_GET_START: {
      ++draft.result.get.processing;
      draft.result.get.error = null;
      return draft;
    }

    case BATCH_SEARCH_RESULT_GET_FULFILL: {
      --draft.result.get.processing;
      draft.result.get.error = null;
      draft.result.data[action.payload.result.id] = action.payload.result;
      return draft;
    }

    case BATCH_SEARCH_RESULT_GET_REJECT: {
      --draft.result.get.processing;
      draft.result.get.error = action.payload;
      return draft;
    }

    case BATCH_SEARCH_RESULT_ADD_TO_REPORT_START: {
      ++draft.result.addToReport.processing;
      draft.result.addToReport.error = null;
      return draft;
    }

    case BATCH_SEARCH_RESULT_ADD_TO_REPORT_FULFILL: {
      --draft.result.addToReport.processing;
      draft.result.addToReport.error = null;
      return draft;
    }

    case BATCH_SEARCH_RESULT_ADD_TO_REPORT_REJECT: {
      --draft.result.addToReport.processing;
      draft.result.addToReport.error = action.payload;
      return draft;
    }

    default:
      return draft;
  }
}, defaultState);
